import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl, AbstractControlDirective, FormsModule, ReactiveFormsModule, ValidationErrors } from '@angular/forms';

@Component({
  selector: 'app-form-errors',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './form-errors.component.html',
  styleUrls: ['./form-errors.component.css']
})
export class FormErrorsComponent {
  errorMsgList: string[] = [];

  @Input() showErrors: boolean = false;

  private _controlName!: AbstractControl | AbstractControlDirective;
  
  @Input()
  set controlName(value: AbstractControl | AbstractControlDirective | undefined) {
    if (value) {
      this._controlName = value;
    }
  }

  get controlName(): AbstractControl | AbstractControlDirective {
    return this._controlName;
  }

  errorMessage: { [key: string]: (params: ValidationErrors) => string } = {
    'required': (params) => `Este campo es requerido.`,
    'maxlength': (params) => `La cantidad máxima de caracteres permitidos es de ${params['requiredLength']}.`,
    'minlength': (params) => `La cantidad mínima de caracteres permitidos es de ${params['requiredLength']}.`,
    'pattern': (params) => `Formato invalido.`,
    'min': (params) => `El número ingresado debe ser mayor o igual que ${params['min']}.`,
    'max': (params) => `El número ingresado debe ser menor o igual que ${params['max']}.`,
    'whitespace': (params) => `No se permiten espacios en blanco.`,
    'email': (params) => `No es un correo válido.`,
    'lessThan': (params) => `Debe ser menor que ${params['right']}`,
    'lessThanOrEquals': (params) => `Debe ser menor o igual que ${params['right']}`,
    'greaterThan': (params) => `Debe ser mayor que ${params['right']}`,
    'greaterThanOrEquals': (params) => `Debe ser mayor o igual que ${params['right']}`
  };

  listErrors(): string[] {
    if (!this.controlName) return [];

    if (!this.controlName.errors) {
      return [];
    }

    this.errorMsgList = [];

    if (this.showErrors || this.controlName.touched || this.controlName.dirty) {
      Object.keys(this.controlName.errors).forEach((name) => {
        const translator = this.errorMessage[name];
        const parameters = this.controlName.errors ? this.controlName.errors[name] : null;

        if (translator && parameters) {
          this.errorMsgList.push(translator(parameters));
        }
      });
    }

    return this.errorMsgList;
  }
}
